import { redirect, createFileRoute } from "@tanstack/react-router";

import {
  PasswordResetSetPassword,
  PasswordResetError,
  PasswordResetLoading,
} from "@pages/password-reset/password-reset-set-password/password-reset-set-password";

import { usePasswordResetDataStore } from "src/services/password-reset-data-store";

import { makePasswordResetQueryOpts } from "src/services/apiQueries/password-reset";

import { queryClient } from "@config/tanstack/tanstackQuery";

export const Route = createFileRoute(
  "/_passwordreset-layout/reset/$uidb64/$token",
)({
  component: PasswordResetSetPassword,
  loader: async (ctx) => {
    const { token, uidb64 } = ctx.params;

    const qOpts = makePasswordResetQueryOpts(token, uidb64, true);
    // await here 1) so pendingComponent shows and 2) so if fails, errorComponent shows
    await queryClient.ensureQueryData(qOpts);

    usePasswordResetDataStore.setState({ passwordResetToken: token });

    throw redirect({
      to: "/reset/$uidb64/set-password",
      params: { uidb64 },
    });
  },
  errorComponent: PasswordResetError,
  pendingComponent: PasswordResetLoading,
});
